if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.galleryInitialized = false;
      }

      connectedCallback() {
        super.connectedCallback();
        this.initArohiGallery();
      }

      initArohiGallery() {
        if (this.galleryInitialized) return;
        this.galleryInitialized = true;

        const backBtn = this.querySelector('.arohi-modal__back');
        if (backBtn) {
          backBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hide();
          });
        }

        const closeBtn = this.querySelector('.arohi-modal__close, [id^="ModalClose-"]');
        if (closeBtn) {
          closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hide();
          });
        }

        const prevBtn = this.querySelector('.arohi-modal__arrow--prev');
        if (prevBtn) {
          prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.prevSlide();
          });
        }

        const nextBtn = this.querySelector('.arohi-modal__arrow--next');
        if (nextBtn) {
          nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.nextSlide();
          });
        }

        // Thumbnails
        const thumbs = this.querySelectorAll('.arohi-modal__thumb');
        thumbs.forEach((thumb, idx) => {
          thumb.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.goToSlide(idx);
          });
        });

        // Close on clicking backdrop
        const mainArea = this.querySelector('.arohi-modal__main');
        if (mainArea) {
          mainArea.addEventListener('click', (e) => {
            if (e.target === mainArea || e.target.classList.contains('arohi-modal__slides')) {
              this.hide();
            }
          });
        }

        // Keyboard navigation
        window.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.prevSlide();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.nextSlide();
          }
        });

        // Touch swipe support for mobile
        let touchStartX = 0;
        let touchEndX = 0;
        const slidesContainer = this.querySelector('.arohi-modal__slides');
        if (slidesContainer) {
          slidesContainer.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
          }, { passive: true });

          slidesContainer.addEventListener('touchend', (e) => {
            touchEndX = e.changedTouches[0].screenX;
            const diff = touchEndX - touchStartX;
            if (Math.abs(diff) > 40) {
              if (diff > 0) {
                this.prevSlide();
              } else {
                this.nextSlide();
              }
            }
          }, { passive: true });
        }
      }

      show(opener) {
        super.show(opener);
        this.initArohiGallery();
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy ? (
          this.openedBy.getAttribute('data-media-id') ||
          this.openedBy.querySelector('[data-media-id]')?.getAttribute('data-media-id')
        ) : null;

        const slides = Array.from(this.querySelectorAll('.arohi-modal__slide'));
        if (!slides.length) return;

        let targetIndex = 0;
        if (openedMediaId) {
          const foundIdx = slides.findIndex((s) => {
            const sId = s.getAttribute('data-media-id');
            return sId && (sId === openedMediaId || openedMediaId.includes(sId) || sId.includes(openedMediaId));
          });
          if (foundIdx !== -1) targetIndex = foundIdx;
        }

        this.goToSlide(targetIndex);
      }

      goToSlide(index) {
        const slides = Array.from(this.querySelectorAll('.arohi-modal__slide'));
        const thumbs = Array.from(this.querySelectorAll('.arohi-modal__thumb'));
        if (!slides.length) return;

        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        this.currentIndex = index;

        slides.forEach((slide, i) => {
          if (i === index) {
            slide.classList.add('is-active');
            const deferred = slide.querySelector('deferred-media');
            if (deferred && typeof deferred.loadContent === 'function') deferred.loadContent();
          } else {
            slide.classList.remove('is-active');
          }
        });

        thumbs.forEach((thumb, i) => {
          if (i === index) {
            thumb.classList.add('is-active');
            thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          } else {
            thumb.classList.remove('is-active');
          }
        });
      }

      prevSlide() {
        this.goToSlide(this.currentIndex - 1);
      }

      nextSlide() {
        this.goToSlide(this.currentIndex + 1);
      }
    }
  );
}
